import type { SignalType } from 'types/signals'
import { SATS_BEFORE_CONFIRM } from 'lib/bsv-util'
import { paidSignalTypeForTarget } from './signalOwnership'

export type QuickUpvalueEligibility = {
    signalType: SignalType
    ownsTarget: boolean
    nextPressIsFree: boolean
    upvaluesEnabled: boolean
    freeReactionAvailable: boolean
    upvalueSats: number
    boostSats: number
}

export type QuickUpvaluePlan =
    | { kind: 'free' }
    | { kind: 'paid'; sats: number; type: SignalType; confirm: boolean }
    | { kind: 'blocked' }

/**
 * What one tap of a quick upvalue does, by the same rules as the answer's quick
 * signal button: a free first reaction, else a paid upvalue (a boost on your
 * own target) at the viewer's default amount, confirmed when it's large.
 */
export function planQuickUpvalue({
    signalType,
    ownsTarget,
    nextPressIsFree,
    upvaluesEnabled,
    freeReactionAvailable,
    upvalueSats,
    boostSats,
}: QuickUpvalueEligibility): QuickUpvaluePlan {
    if (nextPressIsFree || (!upvaluesEnabled && freeReactionAvailable)) return { kind: 'free' }
    if (!upvaluesEnabled) return { kind: 'blocked' }

    const type = paidSignalTypeForTarget(signalType, ownsTarget)
    if (type === 'boost') return { kind: 'paid', sats: boostSats, type, confirm: false }
    if (type === 'upvalue') {
        return {
            kind: 'paid',
            sats: upvalueSats,
            type,
            confirm: upvalueSats > SATS_BEFORE_CONFIRM,
        }
    }
    return { kind: 'blocked' }
}
